export default __webpack_public_path__ + "static/media/blueClock.409f427e.svg";